import { render } from "./CouponsTabs.vue?vue&type=template&id=043e9c0a"
import script from "./CouponsTabs.vue?vue&type=script&lang=js"
export * from "./CouponsTabs.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__